import {useNavigation} from '@react-navigation/native';
import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import OfferDestinationList from 'components/Offers/Filters/DestinationList';
import {Routes} from 'models/Navigation';
import {OfferFiltersDestination} from 'models/OfferFilters';
import {OffersActions} from 'store/offers/offers.reducer';
import {destinationsOfferCount} from 'store/offers/offers.selectors';

const ConnectedOfferDestinationList = ({
  selected,
  destinations,
  availableProperties,
}) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const offersCount = useSelector(destinationsOfferCount);

  const onSelect = useCallback(
    (selectedDestination: OfferFiltersDestination | undefined) => {
      dispatch(OffersActions.setSelectedDestinationFilter(selectedDestination));
      navigation.navigate(Routes.Offers.Properties);
    },
    [dispatch, navigation]
  );

  return (
    <OfferDestinationList
      selected={selected}
      onSelect={onSelect}
      destinations={destinations}
      availableProperties={availableProperties}
      offersCount={offersCount}
    />
  );
};

export default ConnectedOfferDestinationList;
